import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => {
    return {
        tooltip: {
            backgroundColor: theme.palette.background.default,
            boxShadow: theme.shadows[5],
            borderRadius: theme.spacing(1),
            position: "relative",
            zIndex: 1000,
            pointerEvents: "auto",
            "& p": {
                fontSize: "12px",
            },
        },
        container: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            maxHeight: "240px",
            overflowY: "auto",
            padding: theme.spacing(0.5, 1)
        },
        body: {
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
        },
        headerView: {
            borderBottom: "0.5px solid lightGrey",
            "& p": {
                fontWeight: 600
            }
        },
    }
});


